module.exports = __webpack_public_path__ + "static/img/Investigation.55fa6cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/doctors/Investigation.png
// module id = CzQR
// module chunks = 7